import React, { useEffect, useState } from 'react';
import { createRoot } from 'react-dom/client';
import { Modal, Button, Form, CloseButton } from 'react-bootstrap';
import { signOut } from 'firebase/auth';
import { getAuthConfig } from './firebase';
import { toast } from 'react-hot-toast';
import { useTranslation } from 'react-i18next';

export function openNewPasswordModel(next, nextInput) {
  const div = document.createElement('div');
  document.body.appendChild(div);
  const root = createRoot(div);
  const close = () => {
    root.unmount();
    div.remove();
  };

  root.render(
    <NewPasswordModal
      show={true}
      onPasswordEntered={next}
      close={close}
      input={nextInput}
    />
  );
}

export function NewPasswordModal(props) {
  const { t } = useTranslation();
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [passwordsMatch, setPasswordsMatch] = useState(true);
  const [isWithPassword, setIsWithPassword] = useState(false);

  const [agreements, setAgreements] = useState({
    termsAgreed: false,
    privacyPolicyAgreed: false,
  });
  const [disableBtn, setDisableBtn] = useState(true);

  useEffect(() => {
    validateInputs();
  }, [agreements, passwordsMatch, confirmPassword]);
  // this func responsible to sign out user in case cancel create wallet process by click close btn or click outside the modal
  const socialLogout = async () => {
    const auth = await getAuthConfig();
    signOut(auth);
  };
  const handleCheckboxChange = (checkbox) => {
    setAgreements((prevAgreements) => ({
      ...prevAgreements,
      [checkbox]: !prevAgreements[checkbox],
    }));
  };
  const isAgreementAccept = () => {
    return agreements.termsAgreed && agreements.privacyPolicyAgreed;
  };
  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
    setPasswordsMatch(event.target.value === confirmPassword);
  };

  const handleConfirmPasswordChange = (event) => {
    setConfirmPassword(event.target.value);
    setPasswordsMatch(event.target.value === password);
  };

  const handleSubmit = () => {
    if (password === '') {
      toast.error('Please Enter a password or choose without password');
      return;
    }
    if (!passwordsMatch) {
      toast.error("Password doesn't match!");
      return;
    }
    props.onPasswordEntered(password, props.input);
    props.close();
  };

  const handleCancel = async () => {
    props.onPasswordEntered(null);
    await socialLogout();
    props.close();
  };

  const handleWithoutPassword = () => {
    props.onPasswordEntered('', props.input);
    props.close();
  };
  const prepareCreateWallet = (event) => {
    if (!isAgreementAccept()) {
      toast.error(
        `Please Accept ${!agreements.termsAgreed ? 'Terms and condition' : 'Privacy Policy'
        }.`
      );
      return;
    }
    event.preventDefault();

    if (isWithPassword) {
      handleSubmit(event);
    } else {
      handleWithoutPassword();
    }
  };

  const validateInputs = () => {
    if (isAgreementAccept() && !isWithPassword && passwordsMatch) {
      setDisableBtn(false);
    } else if (isAgreementAccept() && isWithPassword) {
      setDisableBtn(false);
    } else setDisableBtn(true);
  };

  return (
    <Modal
      show={props.show}
      onHide={handleCancel}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      id="password-modal"
    >
      <Modal.Header>
        <Modal.Title id="contained-modal-title-vcenter">
          {t("horuspassmodalGmail.header")}
        </Modal.Title>
        <CloseButton
          onClick={handleCancel}
          className="btn-close-white"
          style={{ position: 'absolute', right: '20px', top: '20px' }}
        />
      </Modal.Header>
      <Modal.Body>
        <p>{t("horuspassmodalGmail.subHeader")}</p>
        <p>
          {t("horuspassmodalGmail.note")}
        </p>
        <b />
        <Form onSubmit={handleSubmit}>
          <div className="pt-3">
            <div className="d-flex align-items-center px-8 mb-4">
              <input
                id="default-checkbox"
                type="checkbox"
                checked={agreements.termsAgreed}
                onChange={() => handleCheckboxChange('termsAgreed')}
                className="checkbox"
              />
              <label
                htmlFor="default-checkbox"
                className="ms-2 text-antiFlashWhite-100 dark:text-gray-300 text-sm font-medium"
              >
                <a
                  href="https://horuswallet.com/terms"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:underline"
                > {t("horuspassmodalGmail.agreeTo")}

                </a>
              </label>
            </div>
            <div className="d-flex align-items-center px-8 mb-4">
              <input
                id="checked-checkbox"
                type="checkbox"
                checked={agreements.privacyPolicyAgreed}
                onChange={() => handleCheckboxChange('privacyPolicyAgreed')}
                className="checkbox"
              />
              <label
                htmlFor="checked-checkbox"
                className="ms-2 text-antiFlashWhite-100 dark:text-gray-300 text-sm font-medium"
              >
                <a
                  href="https://horuswallet.com/privacyPolicy"
                  target="_blank"
                  rel="noopener noreferrer"
                  className=""
                >
                  {t("horuspassmodalGmail.agreethe")}
                </a>
              </label>
            </div>
            <div className="d-flex align-items-center px-8 mb-4">
              <input
                id="checked-withpassword"
                type="checkbox"
                checked={isWithPassword}
                onChange={(e) => setIsWithPassword(e.target.checked)}
                className="checkbox"
              />
              <label
                htmlFor="checked-checkbox"
                className="ms-2 text-antiFlashWhite-100 dark:text-gray-300 text-sm font-medium"
              >
                <span>{t("horuspassmodalGmail.pass")}  </span>
              </label>
            </div>
          </div>
          {isWithPassword && (
            <>
              <Form.Group controlId="formPassword">
                <Form.Control
                  type="password"
                  placeholder={t("horuspassmodalGmail.enterPass")}
                  value={password}
                  onChange={handlePasswordChange}
                  isInvalid={!passwordsMatch}
                />
              </Form.Group>
              <br />
              <Form.Group controlId="formConfirmPassword">
                <Form.Control
                  type="password"
                  placeholder={t("horuspassmodalGmail.confirmPass")}
                  value={confirmPassword}
                  onChange={handleConfirmPasswordChange}
                  isInvalid={!passwordsMatch}
                />
                <Form.Control.Feedback type="invalid">
                  Passwords do not match
                </Form.Control.Feedback>
              </Form.Group>
            </>
          )}
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <div className="fugu--portfolio-btn">
          <button
            className={`fugu--outline-btn ${disableBtn ? 'invalid' : 'valid'}`}
            onClick={prepareCreateWallet}
            disabled={disableBtn}
          >
            <span>{t("horuspassmodalGmail.createWallet")}</span>
          </button>
        </div>
        <div className="fugu--portfolio-btn">
          <button className="fugu--outline-btn" onClick={handleCancel}>
            <span>{t("horuspassmodalGmail.cancel")}</span>
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
